import { render, staticRenderFns } from "./moneylist.vue?vue&type=template&id=fffd195e&scoped=true&"
import script from "./moneylist.vue?vue&type=script&lang=js&"
export * from "./moneylist.vue?vue&type=script&lang=js&"
import style0 from "./moneylist.vue?vue&type=style&index=0&id=fffd195e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fffd195e",
  null
  
)

export default component.exports